/* eslint-disable camelcase */
import { ActionType } from 'typesafe-actions';
import * as actions from './actions';
import { cartProductProps } from '../checkout/types';

export type ProductAction = ActionType<typeof actions>;

/**
 * Action types
 */
export enum ProductActionTypes {
  RECHARGE = '@product/RECHARGE',
  LOAD_REQUEST = '@product/LOAD_REQUEST',
  LOAD_SUCCCES = '@product/LOAD_SUCCCES',
  LOAD_SUCCESS_NEXT_PAGE = '@product/LOAD_SUCCCES_NEXT_PAGE',
  LOAD_FAILURE = '@product/LOAD_FAILURE',
  RESPONSE_SUCCCES = '@product/RESPONSE_SUCCCES',
  SEARCH_REQUEST = '@product/SEARCH_REQUEST',
  SEARCH_REQUEST_SUCCESS = '@product/SEARCH_REQUEST_SUCCESS',
  DETAILS = '@product/DETAILS',
  SET_FILTERS = '@product/SET_FILTERS',
  SEARCH_PRODUCT = '@product/SEARCH_PRODUCT',
  SEARCH_PRODUCT_SUCCESS = '@product/SEARCH_PRODUCT_SUCCESS',
  CLEAR_PRODUCTS = '@product/CLEAR_PRODUCTS'
}

export interface FindProductProps {
  categoryId?: string;
  priceMin?: number;
  priceMax?: number;
  moreProducts?: number;
  order?: string;
  term?: string;
  moreScroll?: boolean | false;
  hasMore?: boolean | true;
  id?: string;
  page?: number;
  limit?: number;
}

export interface productData {
  type?: string;
  products?: ProductData;
}
export interface ResponseProps {
  to?: string;
  total?: string;
  currentPage: number;
  lastPage: number;
}

export interface CategoryData {
  id?: string;
  short_description: string;
  long_description: string;
}

export interface GalleryImages {
  small_image_url?: string;
  medium_image_url?: string;
  large_image_url?: string;
  original_image_url?: string;
}

export interface ServicesProps {
  service_id: number,
  product_service_id: number,
  service_name: string,
  service_report_header: string,
  service_report_detail: string,
  service_report_footer: string,
  service_display_name: string,
  service_period: number,
  service_price: string,
}

export interface ProductPrices {
  type?: number;
  price?: string;
  start?: string;
  end?: string;
  code_promotion?: number;
}

export interface AtributesProps {
  label: string,
  value: string,
}

// Generated by https://quicktype.io


export interface RelationProps {
  variation: string;
  label: string;
  products: RelationProductProps[];
}

export interface RelationProductProps {
  id: number;
  sku: string;
  short_description: string;
  image_url?: string;
  variation_label: string;
  variation_code: string;
}

export interface ItemAtributesProps {
  label: string,
  value: string,
}
;
export interface ProductData {
  /**
   *  Campos basicos para o produtos
   */

  id?: string;
  sku?: string;
  product_id?: string;
  short_description?: string;
  long_description?: string;

  category?: CategoryData;
  price?: number;
  min_qty?: string;
  max_qty?: string;

  image_url?: '';

  gallery_images?: GalleryImages[];
  info_to_customer?: string;
  un?: string;
  base_qty?: string;

  prices?: ProductPrices[];

  /**
   *  Campos adiconais
   */

  stars?: number;
  discount_amount?: string;
  quantity?: number;
  quantityAfter?: number;
  additional?: cartProductProps;

  send?: boolean;

  /**
   *  Campos para carrinho
   */

  cart_item_id?: number;

  /**
   *  Campos para orderm
   */

  order_item_id?: number;
  product?: ProductData;
  qty_ordered?: number;
  grant_total?: number;


  /*
    Campos para serviço
  */
  services?: ServicesProps[];

  /*
    Campos para Atributos
  */
  attributes?: AtributesProps[];
  /*
    Campos para Relações
  */
  relations?: RelationProps[];

  quantity_increment?: number;

  is_available?: number;
}

export interface ProductState {
  readonly products: ProductData[];
  readonly product: ProductData;
  readonly productDetalails: ProductData;
  readonly search: ProductData[];
  readonly response: ResponseProps;
  readonly filters: FindProductProps;
  readonly loading: boolean;
  readonly loadingSearch: boolean;
  readonly loadingProduct: boolean;
  readonly error: boolean;
}
